import Model from './model.js'
import Contact from './contact.js'

export default class Communication extends Model {
	tailIgnore = ['company_id', 'owner_id', 'owner_type', 'type', 'deleted_at']
	tail = {
		value: () => [this.label(), this.toString()],
		// primary: () => ['Primary ' + this.name(), this.primary],
		createdDescription: () => this.toString() + ' was created',
		removedDescription: () => this.toString() + ' was deleted',
	}

	_constructor() {
		if (this.owner != null) {
			this.owner = new Contact(this.owner, { $help: this.$help, vue: this.vue })
		}
	}

	_logIcon() {
		console.log(this)
		return 'IconUserDraftCircle'
		return this.description.toLowerCase().indexOf('email') >= 0 ? 'IconEmailDraftCircle' : 'IconPhoneDraftCircle'
	}

	me() {
		return this.label()
	}

	toString() {
		return parseInt(this.type) === 0 ? this.$help.e164ToNumber(this.value) : this.value
	}

	label() {
		return parseInt(this.type) === 0 ? 'phone number' : 'email address'
	}

	name() {
		return parseInt(this.type) === 0 ? 'number' : 'email'
	}

	action() {
		return parseInt(this.type) === 0 ? 'call' : 'email'
	}
}
